<template>
  <v-dialog width="400px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="material">
          <v-flex xs3>
            <v-subheader class="px-0" v-text="'Name:'"></v-subheader>                  
          </v-flex>
          <v-flex xs9>
            <v-text-field label="Name" type="text" v-model="material.name" required></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-subheader class="px-0" v-text="'Emodul:'"></v-subheader>                  
          </v-flex>       
          <v-flex xs9>
              <v-text-field label="Emodul" type="number" v-model.number.lazy="material.Emodul" :suffix="KraftEinheit.name + '/' + LängenEinheit.name + '²'" required></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-subheader class="px-0" v-text="'Wichte:'"></v-subheader>                  
          </v-flex>         
          <v-flex xs9>
              <v-text-field label="Wichte" type="number" v-model.number.lazy="material.Wichte" :suffix="KraftEinheit.name + '/' + LängenEinheit.name + '³'" required></v-text-field>
          </v-flex>        
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn small v-if="!$store.getters.newMaterial" @click="deleteMaterial()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Material from '../../js/Material.js'

export default {
    data(){
        return{
            material: undefined,
            LängenEinheit: this.$store.state.LängenEinheiten.cm,
            KraftEinheit: this.$store.state.KraftEinheiten.kN
        }
    },
    computed: {
        title() { return this.$store.getters.newMaterial == true ? 'Neues Material' : 'Material Bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vMaterialMenu },   
            set(value) { this.$store.commit('setvMaterialMenu', value)} 
        },
        cMaterial() { return this.$store.getters.cMaterial },
    },
    methods: {
        apply(){
            this.material.Emodul = this.material.Emodul*this.KraftEinheit.value/this.LängenEinheit.value/this.LängenEinheit.value
            this.material.Wichte = this.material.Wichte*this.KraftEinheit.value/this.LängenEinheit.value/this.LängenEinheit.value/this.LängenEinheit.value
            this.$store.commit('MaterialDialogApply', this.material)
            this.material = undefined
        },
        cancel(){
            this.viewMenu = false
            this.material = undefined
        },
        deleteMaterial(){
            this.$store.commit('MaterialDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.material && this.viewMenu) {
            const cEmodul = this.cMaterial.Emodul/this.KraftEinheit.value*this.LängenEinheit.value*this.LängenEinheit.value
            const cWichte = this.cMaterial.Wichte/this.KraftEinheit.value*this.LängenEinheit.value*this.LängenEinheit.value*this.LängenEinheit.value
          this.material = new Material(null, cEmodul, cWichte, this.cMaterial.name)
        } 
    },
}
</script>